export const FigmaDemo = 'cognos-demo-v2.json';
export const FigmaToken = 'FigmaData.json';
